import React from 'react';
import { Icon } from './Icon.js';
export const IconEarphoneLeftSound = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M3 8V19H7V11L11 10V3H8C5.23858 3 3 5.23858 3 8Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M13 18C15.2091 18 17 19.7909 17 22", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", fill: "none" }),
        React.createElement("path", { d: "M13 14C17.4183 14 21 17.5817 21 22", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", fill: "none" })));
};
//# sourceMappingURL=IconEarphoneLeftSound.js.map